import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {TooltipAndOverlayIDs} from '../../v2/components/detailed-tooltip/TooltipLibrary';
import Message from '../../v2/components/ui/Message/Message';
import Translation from '../../v2/lang/Translation';
import SubscriptionInformationContent from './SubscriptionInformationContent';
import GenericSection from '../GenericSection/GenericSection';

export function SubscriptionInformationSectionWrapper(props) {
  return (
    <div data-test="SubscriptionInformationSection">
      <GenericSection
        id="subscriptionInformationSection"
        className="subscriptionInformationSection"
        headerKey="checkout.subscription.information.section.heading.text"
        expandable={!props.subscriptionNotLoadableYet}
        expandableContent={<SubscriptionInformationContent />}
        expandableModalId={TooltipAndOverlayIDs.SUBSCRIPTION}
        noMarginTop
      >
        {props.subscriptionNotLoadableYet && (
          <div data-test="SubscriptionInformationSection__infoMsg_notLoaded">
            <Message>
              <Translation>checkout.subscription.information.section.info.notLoadedMessage.text</Translation>
            </Message>
          </div>
        )}
      </GenericSection>
    </div>
  );
}

SubscriptionInformationSectionWrapper.propTypes = {
  subscriptionNotLoadableYet: PropTypes.bool,
};

const mapStateToProps = state => ({
  subscriptionNotLoadableYet: state.deliveryOption.status === 'requireData' || state.deliveryOption.status === 'loading',
});

export default connect(mapStateToProps)(SubscriptionInformationSectionWrapper);
